import RequestStatusesList from "./request-statuses-list";

export default RequestStatusesList;
